import { render, staticRenderFns } from "./ExamViewDialog.vue?vue&type=template&id=8905c8a2&scoped=true"
import script from "./ExamViewDialog.vue?vue&type=script&lang=js"
export * from "./ExamViewDialog.vue?vue&type=script&lang=js"
import style0 from "./ExamViewDialog.vue?vue&type=style&index=0&id=8905c8a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8905c8a2",
  null
  
)

export default component.exports